import { z } from 'zod';
/**
 * Rolle einer Person INNERHALB eines Projekts (nicht zu verwechseln mit der
 * System-Rolle aus `UserRole`).
 *
 *   lead     → Verantwortlicher — genau EINER je Projekt. Das Backend löst den
 *              bisherigen automatisch ab, wenn ein neuer ernannt wird.
 *   editor   → Vertreter — beliebig viele, optional.
 *   reviewer → Mitleser mit Prüfblick.
 *   observer → reiner Mitleser.
 *
 * Vergeben darf diese Rollen ausschließlich der Admin (Backend erzwingt
 * `USER_MANAGE` an den Assignment-Routen).
 */
export const projectRole = z.enum(['lead', 'editor', 'reviewer', 'observer']);
/** Verantwortlicher — genau einer je Projekt. */
export const RESPONSIBLE_PROJECT_ROLE = 'lead';
/** Vertreter — beliebig viele, optional. */
export const DEPUTY_PROJECT_ROLE = 'editor';
/** Deutsche Anzeigenamen der Projekt-Rollen (UI + Fehlermeldungen). */
export const PROJECT_ROLE_LABELS = {
    lead: 'Verantwortlicher',
    editor: 'Vertreter',
    reviewer: 'Prüfer',
    observer: 'Beobachter',
};
export const projectAssignment = z.object({
    id: z.number().int().positive(),
    projectId: z.number().int().positive(),
    userId: z.number().int().positive(),
    role: projectRole,
    assignedById: z.number().int().positive(),
    assignedAt: z.string().datetime(),
    removedAt: z.string().datetime().nullable().optional(),
    user: z
        .object({
        id: z.number().int().positive(),
        fullName: z.string(),
        email: z.string().email(),
        role: z.string(),
    })
        .optional(),
});
export const createAssignmentRequest = z
    .object({
    userId: z.number().int().positive(),
    role: projectRole,
})
    .strict();
export const updateAssignmentRequest = z
    .object({
    role: projectRole,
})
    .strict();
